var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path==='/'
  || _vm.path==='/activity'
  // || path==='/orderHistoryInfo'
  // || path==='/usercenter'
  || _vm.path === '/main'
  || _vm.path == '/yueIndex'
  || _vm.path == '/yueOouyanMini'
  // || path == '/yueOrderList'
)?_c('div',[_c('div',{staticClass:"nav-buttom"},[_c('x-button',{attrs:{"type":"primary","link":{path:'/usercenter/orderList'}}},[_vm._v("个人订单")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da3ed43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabbarIndex.vue
// module id = null
// module chunks = 